/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable array-callback-return */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";
import ClearIcon from "@mui/icons-material/Clear";
import { ZoomIn, ZoomOut, RestartAlt } from "@mui/icons-material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  TextField,
  Button,
  Alert,
  Paper,
  Typography,
  FormControl,
  Box,
  Snackbar,
  Grid,
  CardContent,
  Modal,
  Card,
  IconButton,
  FormControlLabel,
  Checkbox,
  Breadcrumbs as MuiBreadcrumbs,
  Link,
  Autocomplete,
  Avatar,
  CircularProgress,
} from "@mui/material";
import { spacing } from "@mui/system";

import { NavLink, useNavigate, useParams } from "react-router-dom";
import { Formik } from "formik";
import DocumentUpload from "../components/DocumentUpload";
import axios from "../../CustomAxios";
import Loading from "../components/Loading";
import { connect } from "react-redux";

let states = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttarakhand",
  "Uttar Pradesh",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli",
  "Daman and Diu",
  "Delhi",
  "Lakshadweep",
  "Puducherry",
];

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Mob = styled.div`
  ${(props) => props.theme.breakpoints.down("md")} {
    display: none;
  }
`;

const BigAvatar = styled(Avatar)`
  width: 92px;
  height: 92px;
  text-align: center;
  margin: 0 auto ${(props) => props.theme.spacing(5)};
`;

function Signup({
  roles,
  companies,
  user,
  id,
  details,
  comp,
  urls,
  up,
  setUp,
  setUrls,
}) {
  const [is_deleted, setIsDeleted] = useState(details.is_deleted);
  // useEffect(() => {
  //   console.log(urls);
  // }, [urls]);
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const snackRef = useRef(null);
  const [state, setState] = useState({
    op: false,
    vertical: "top",
    horizontal: "center",
  });

  const submit = async (values) => {
    try {
      setLoader(true);
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };

      let url = "";
      if (authData?.type === "customer_user") {
        url = `/api/v1/customer_user/ops/${id}`;
      } else {
        url = `/api/v1/${authData?.type}/customer_company_user/${id}`;
      }
      const role = values.role._id || values.role.role_id;
      const { data } = await axios.put(
        url,
        {
          name: values.name,
          email_address: values.email_address,
          phone_number: values.phone_number.includes("+91")
            ? values.phone_number
            : "+91" + values.phone_number,
          role,
          customer_company: values.company._id,
          address_line_one: values.address_one,
          address_line_two: values.address_two,
          pincode: values.pincode,
          state: values.state,
          city: values.city,
          is_deleted: is_deleted,
        },
        config
      );
      if (data.success) {
        setErr("");
        setSuccess(true);
        snackRef.current.click();
        navigate("/dashboard/users/customer-users", {
          state: {
            message: "Customer User Details Updated Successfully",
            success: true,
          },
        });
      }
      setLoader(false);
    } catch (e) {
      setErr(e.response.data.error);
      snackRef.current.click();
      setLoader(false);
      console.log(e);
    }
  };

  const { vertical, horizontal, op } = state;
  const handleClick = (newState) => () => {
    setState({ op: true, ...newState });
  };
  const handleCloseSnack = () => {
    setState({ ...state, op: false });
  };
  const authData = JSON.parse(localStorage.getItem("AuthData"));

  const [message, setMessage] = useState("");
  const handleClose = () => setOpen(false);
  const [del, setDelete] = useState(false);
  const [openAddDoc, setOpenAdddoc] = useState(false);
  const [u, setU] = useState();
  const [type, setType] = useState();
  const handleOpen = (url, type) => {
    // if(type!=="pdf"){

    setU(url);
    setType(type);
    setOpen(true);
    setModalImgHeight(70);
    // }else{
    // window.open(url)
    // }
  };
  const [modalImgHeight, setModalImgHeight] = useState(70);
  const handleDownDoc = () => {
    setOpenAdddoc(false);
    setImages({});
    setDocuments({});
  };
  const [open, setOpen] = useState(false);
  const [documents, setDocuments] = useState({});
  const [images, setImages] = useState({});
  const handleOpenDoc = () => {
    setOpenAdddoc(true);
  };

  const [imgValue, setImgVal] = useState(null);
  const [profileLoader, setProfileLoader] = useState(false);
  const [documentLoader, setDocumentLoader] = useState(false);
  const [profile, setProfile] = useState();

  const inputFile = useRef(null);
  const onButtonClick = () => {
    inputFile.current.click();
  };

  useEffect(() => {
    let pf = urls.find((item) => item.name === "profile_picture");
    setProfile(pf !== undefined ? pf.url : "");
  }, [urls]);

  const formData = new FormData();

  const handleProfileChange = async () => {
    try {
      setProfileLoader(true);
      let formDt = new FormData();
      formDt.set("profile_picture", imgValue);
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };

      const { data } = await axios.post(
        `/api/v1/${authData?.type}/media/customer_user/${id}`,
        formDt,
        config
      );

      if (data.success) {
        setSuccess(true);
        setErr("");
        setMessage("Documents Added Successfully");
        snackRef.current.click();
        // window.location.reload();
        setUrls([]);
        setUp(up + 1);
        setProfileLoader(false);
      }
    } catch (error) {
      setErr(error.response.data.error);
      snackRef.current.click();
      setLoader(false);
      console.log(error);
      setProfileLoader(false);
    }
  };

  const deleteDocument = async (key) => {
    try {
      // setLoader(true);
      setDelete(false);
      setDocumentLoader(true);

      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      let url = "";
      if (authData?.type === "customer_user") {
        url = `/api/v1/${authData?.type}/${comp}/media/customer_user/${id}/${key}`;
      } else {
        url = `/api/v1/${authData?.type}/media/customer_user/${id}/${key}`;
      }
      const { data } = await axios.delete(url, config);
      if (data.success) {
        setSuccess(true);
        setErr("");
        setMessage("Document Deleted successfully");
        snackRef.current.click();
        // window.location.reload();
        setUrls([]);
        setUp(up + 1);
        setDocumentLoader(false);
      }
    } catch (e) {
      setErr(e.response.data.error);
      snackRef.current.click();
      setLoader(false);
      console.log(e);
      setDocumentLoader(false);
    }
  };

  const addDocuments = async () => {
    try {
      setDocumentLoader(true);

      let br = 0;
      Object.values(images).map((doc, i) => {
        if (!documents[i]) {
          setErr("Document Name field cannot be empty");
          setSuccess(false);
          snackRef.current.click();
          br = 1;
          return;
        }
      });
      if (!br) {
        // setLoader(true);
        handleDownDoc();
        const authData = JSON.parse(localStorage.getItem("AuthData"));
        Object.values(images).map((image, i) => {
          formData.set(`document_${i + 1}_file`, image);
        });
        Object.values(documents).map((doc, i) => {
          formData.set(`document_${i + 1}_name`, doc);
        });
        const config = {
          headers: {
            Authorization: "Bearer " + authData.access_token,
          },
        };
        let url = "";
        if (authData?.type === "customer_user") {
          url = `/api/v1/${authData?.type}/${comp}/media/customer_user/${id}`;
        } else {
          url = `/api/v1/${authData?.type}/media/customer_user/${id}`;
        }
        const { data } = await axios.post(url, formData, config);
        if (data.success) {
          setSuccess(true);
          setErr("");
          setMessage("Documents Added Successfully");
          snackRef.current.click();
          // window.location.reload();
          setUrls([]);
          setUp(up + 1);
          setDocumentLoader(false);
        }
      }
    } catch (e) {
      setErr(e.response.data.error);
      snackRef.current.click();
      setLoader(false);
      console.log(e);
      setDocumentLoader(false);
    }
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    // width: 400,
    bgcolor: "background.paper",
    // bgcolor: 'transparent',
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  return (
    <Formik
      initialValues={{
        email_address: details.email_address,
        phone_number: details.phone_number,
        name: details.name,
        address_one: details.address_line_one,
        address_two: details.address_line_two,
        pincode: details.pincode,
        state: details.state,
        city: details.city,
        role: details.role,
        company: details?.customer_company,
        submit: false,
      }}
      validationSchema={Yup.object().shape({
        email_address: Yup.string()
          .email("Must be a valid email")
          .max(255)
          .required("Email is required"),
        name: Yup.string().max(255).required("name is required"),
        address_one: Yup.string()
          .max(1000)
          .required("Address Line 1 is required"),
        address_two: Yup.string()
          .max(1000)
          .required("Address Line 2 is required"),
        pincode: Yup.string().max(1000).required("Pincode is required"),
        state: Yup.string().max(1000).required("State is required"),
        city: Yup.string().max(1000).required("City is required"),
        phone_number: Yup.string()
          .required("Phone Number is required")
          .matches(/^(((\+){1}91){1})?[6-9]{1}[0-9]{9}$/, {
            message: "Invalid Indian number",
            excludeEmptyString: false,
          }),
        role: Yup.object().required("Role is required"),
        company: Yup.object().required("Company is required"),
      })}
      onSubmit={async (
        values,
        { setErrors, setStatus, setSubmitting, resetForm }
      ) => {
        try {
          submit(values);
        } catch (error) {
          const message = error.message || "Something went wrong";

          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        setFieldValue,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <form noValidate onSubmit={handleSubmit}>
          {errors.submit && (
            <Alert mt={2} mb={1} severity="warning">
              {errors.submit}
            </Alert>
          )}
          <Button
            ref={snackRef}
            style={{ display: "none" }}
            onClick={handleClick({ vertical: "top", horizontal: "center" })}
          >
            Click
          </Button>
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            open={op}
            onClose={handleCloseSnack}
            key={vertical + horizontal}
          >
            {err ? (
              <Alert mt={2} mb={4} severity="error">
                {err}
              </Alert>
            ) : success ? (
              <Alert mt={2} mb={4} severity="success">
                {message}
              </Alert>
            ) : null}
          </Snackbar>
          {!loader ? (
            <div>
              <Card mb={6}>
                <CardContent>
                  <Grid container spacing={5}>
                    <Grid item xs={12} lg={12} md={12}>
                      <Typography variant="h6" gutterBottom>
                        Update Customer User
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={12} lg={12}>
                      <BigAvatar
                        onClick={onButtonClick}
                        style={{ cursor: "pointer" }}
                        src={profile}
                      />
                      <input
                        type="file"
                        id="file"
                        ref={inputFile}
                        accept=".png, .jpg, .jpeg"
                        onChange={(e) => {
                          setProfile(URL.createObjectURL(e.target.files[0]));
                          setImgVal(e.target.files[0]);
                        }}
                        style={{ display: "none" }}
                      />
                      <Typography
                        component="h1"
                        variant="h4"
                        align="center"
                        gutterBottom
                      >
                        <Button
                          variant="outlined"
                          onClick={handleProfileChange}
                          disabled={profileLoader}
                        >
                          {profileLoader ? (
                            <>
                              Updating Profile Picture{" "}
                              <CircularProgress
                                size={20}
                                style={{ marginLeft: "8px" }}
                              />
                            </>
                          ) : (
                            "Update Profile picture"
                          )}
                        </Button>
                      </Typography>
                    </Grid>

                    {authData?.type === "customer_user" ? (
                      <Grid item xs={12} md={12} lg={12}>
                        <TextField
                          type="text"
                          fullWidth
                          label="company"
                          value={user?.customer_company?.name}
                          inputProps={{ readOnly: true }}
                        />
                      </Grid>
                    ) : (
                      <Grid item xs={12} md={12} lg={12}>
                        <FormControl
                          fullWidth
                          error={Boolean(touched.company && errors.company)}
                        >
                          <Autocomplete
                            id="combo-box-demo"
                            options={companies}
                            value={values?.company || null}
                            onChange={(event, newValue) => {
                              setFieldValue("company", newValue || "");
                            }}
                            // inputValue={values?.technology?.name}
                            onBlur={handleBlur}
                            getOptionLabel={(option) => option?.name}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={Boolean(
                                  touched.company && errors.company
                                )}
                                helperText={touched.company && errors.company}
                                label="Customer Company"
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>
                    )}
                    <Grid item xs={12} md={12} lg={12}>
                      <TextField
                        type="text"
                        name="name"
                        fullWidth
                        label="name"
                        value={values.name}
                        error={Boolean(touched.name && errors.name)}
                        helperText={touched.name && errors.name}
                        onBlur={handleBlur}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                      <TextField
                        type="email"
                        name="email_address"
                        label="Email address"
                        fullWidth
                        value={values.email_address}
                        error={Boolean(
                          touched.email_address && errors.email_address
                        )}
                        helperText={
                          touched.email_address && errors.email_address
                        }
                        onBlur={handleBlur}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                      <TextField
                        type="text"
                        name="phone_number"
                        label="Phone Number"
                        value={values.phone_number}
                        error={Boolean(
                          touched.phone_number && errors.phone_number
                        )}
                        helperText={touched.phone_number && errors.phone_number}
                        onBlur={handleBlur}
                        fullWidth
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                      <FormControl
                        fullWidth
                        error={Boolean(touched.role && errors.role)}
                      >
                        {roles.data !== undefined ? (
                          <Autocomplete
                            id="combo-box-demo"
                            options={roles.data}
                            value={values?.role || null}
                            onChange={(event, newValue) => {
                              setFieldValue("role", newValue || "");
                            }}
                            // inputValue={values?.technology?.name}
                            onBlur={handleBlur}
                            getOptionLabel={(option) => option?.role_name}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={Boolean(touched.role && errors.role)}
                                helperText={touched.role && errors.role}
                                label="Select Role"
                              />
                            )}
                          />
                        ) : (
                          <TextField label="Select Role" value={"Loading..."} />
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        fullWidth
                        name="address_one"
                        error={Boolean(
                          touched.address_one && errors.address_one
                        )}
                        value={values.address_one}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label={"Address Line 1"}
                        helperText={touched.address_one && errors.address_one}
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        fullWidth
                        name="address_two"
                        error={Boolean(
                          touched.address_two && errors.address_two
                        )}
                        value={values.address_two}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label={"Address Line 2"}
                        helperText={touched.address_two && errors.address_two}
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        fullWidth
                        name="pincode"
                        error={Boolean(touched.pincode && errors.pincode)}
                        value={values.pincode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label={"Pincode"}
                        helperText={touched.pincode && errors.pincode}
                      />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                      <FormControl
                        fullWidth
                        error={Boolean(touched.state && errors.state)}
                      >
                        <Autocomplete
                          id="combo-box-demo"
                          options={states}
                          value={values?.state || ""}
                          onChange={(event, newValue) => {
                            setFieldValue("state", newValue || "");
                          }}
                          // inputValue={values?.technology?.name}
                          onBlur={handleBlur}
                          getOptionLabel={(option) => option}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              error={Boolean(touched.state && errors.state)}
                              helperText={touched.state && errors.state}
                              label="Select State"
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        fullWidth
                        name="city"
                        error={Boolean(touched.city && errors.city)}
                        value={values.city}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label={"City"}
                        helperText={touched.city && errors.city}
                      />
                    </Grid>
                    <Grid item xs={12} lg={3} md={3}>
                      <FormControl
                        fullWidth
                        component="fieldset"
                        variant="standard"
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={is_deleted}
                              onChange={(e) => setIsDeleted(e.target.checked)}
                              inputProps={{ "aria-label": "controlled" }}
                            />
                          }
                          label={"Is Deleted"}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>

              <Modal open={open} onClose={handleClose}>
                <Card sx={style}>
                  <CardContent>
                    <Paper>
                      <Grid container justifyContent="center" spacing={5}>
                        <Grid
                          item
                          xs={12}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <IconButton
                            onClick={() =>
                              setModalImgHeight(modalImgHeight + 5)
                            }
                          >
                            <ZoomIn />
                          </IconButton>
                          <IconButton
                            onClick={() =>
                              setModalImgHeight(modalImgHeight - 5)
                            }
                          >
                            <ZoomOut />
                          </IconButton>
                          <IconButton onClick={() => setModalImgHeight(70)}>
                            <RestartAlt />
                          </IconButton>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            maxHeight: "72.5vh",
                            overflowY: "scroll",
                          }}
                        >
                          {type !== "pdf" ? (
                            <Box
                              component={"img"}
                              src={u}
                              height={modalImgHeight.toString() + "vh"}
                              width="auto"
                            />
                          ) : (
                            <iframe
                              height={(modalImgHeight + 420).toString() + "vh"}
                              width={(modalImgHeight + 420).toString() + "vh"}
                              src={u}
                            />
                          )}
                        </Grid>
                      </Grid>
                    </Paper>
                  </CardContent>
                </Card>
              </Modal>
              <Modal
                open={openAddDoc}
                onClose={handleDownDoc}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    align="center"
                    color="primary"
                  >
                    Add Documents
                  </Typography>
                  <DocumentUpload
                    documents={documents}
                    setDocuments={setDocuments}
                    images={images}
                    setImages={setImages}
                  />
                  <Button onClick={addDocuments}>Add</Button>
                </Box>
              </Modal>
              <Card mb={6}>
                <CardContent>
                  <Paper elevation={3} style={{ padding: "2%" }}>
                    <Grid container spacing={5}>
                      <Grid item xs={12} lg={12} md={12}>
                        <Typography variant="h4" gutterBottom>
                          Document Details
                        </Typography>
                      </Grid>
                      {!details.documents.length ? (
                        <Grid item xs={12} md={12} lg={12}>
                          <Typography variant="h6" color="primary" gutterBottom>
                            No Documents Added
                          </Typography>
                        </Grid>
                      ) : null}
                      {documentLoader ? (
                        "Loading Documents..."
                      ) : (
                        <>
                          {urls &&
                            urls.map((document, i) => {
                              if (urls[i]?.name !== "profile_picture") {
                                return (
                                  <Paper
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      width: "100%",
                                      marginTop: "10px",
                                    }}
                                    mt={3}
                                  >
                                    <Box
                                      component="img"
                                      width="90px"
                                      height="80px"
                                      onClick={() =>
                                        handleOpen(urls[i]?.url, urls[i]?.type)
                                      }
                                      src={
                                        urls[i]?.type === "pdf"
                                          ? "/static/img/images/pdf.png"
                                          : urls[i]?.url
                                      }
                                      style={{ cursor: "pointer" }}
                                    />
                                    <TextField
                                      fullWidth
                                      margin="dense"
                                      m={2}
                                      style={{ marginLeft: 32, width: "100%" }}
                                      inputProps={{ readOnly: true }}
                                      id="standard-required"
                                      label="Document Name"
                                      value={urls[i]?.name || ""}
                                    />
                                    {!del ? (
                                      <Mob>
                                        <Grid item>
                                          <a
                                            href={urls[i]?.url}
                                            style={{
                                              color: "inherit",
                                              textDecoration: "inherit",
                                            }}
                                            download={`${urls[i]?.name}.${urls[i]?.type}`}
                                          >
                                            <FileDownloadIcon
                                              style={{
                                                marginLeft: 32,
                                                cursor: "pointer",
                                              }}
                                            />
                                          </a>
                                        </Grid>
                                      </Mob>
                                    ) : (
                                      <Grid item>
                                        <ClearIcon
                                          onClick={() =>
                                            deleteDocument(urls[i]?.key)
                                          }
                                          style={{
                                            marginLeft: 32,
                                            cursor: "pointer",
                                          }}
                                        />
                                      </Grid>
                                    )}
                                  </Paper>
                                );
                              }
                            })}
                        </>
                      )}
                      <br />
                      {!del ? (
                        <Grid item xs={12} md={12} lg={12}>
                          <Button onClick={handleOpenDoc}>Add Document</Button>
                          <Button
                            onClick={() => setDelete(true)}
                            style={{ color: "red" }}
                          >
                            Delete Document
                          </Button>
                        </Grid>
                      ) : (
                        <Grid item xs={12} md={12} lg={12}>
                          <Button onClick={() => setDelete(false)}>
                            Cancel
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </Paper>
                </CardContent>
              </Card>
              <Grid item xs={12} md={12} lg={12}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                >
                  Update
                </Button>
              </Grid>
            </div>
          ) : (
            <Loading />
          )}
        </form>
      )}
    </Formik>
  );
}

const getDetailsRolesCompanies = async (
  setRoles,
  setCompanies,
  setLoader,
  setDetails,
  id,
  setUrls,
  company
) => {
  try {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };
    let url = "";
    if (userData?.type === "customer_user") {
      url = `/api/v1/customer_user/ops/${id}`;
    } else {
      url = `/api/v1/${userData?.type}/customer_company_user/${id}`;
    }
    const { data } = await axios.get(url, config);
    if (data.success) {
      setDetails(data.data);
      setLinks(data.data.documents, setUrls, setLoader, company);
    }

    if (userData.type === "customer_user") {
      const roledata = await axios.get(`/api/v1/${userData.type}/role`, config);
      if (roledata.data.success) {
        setRoles(roledata.data.data);
      }
    } else {
      const roledata = await axios.get(
        `/api/v1/${userData.type}/role?user_type=customer_company_user`,
        config
      );
      if (roledata.data.success) {
        setRoles(roledata.data.data);
      }
    }

    const companydata = await axios.get(
      `/api/v1/${userData.type}/customer_company?limit=500`,
      config
    );
    if (companydata.data.success) {
      setCompanies(companydata.data.data.data);
    }
  } catch (e) {
    setLoader(false);
    console.log(e);
  }
};

const setLinks = (document, setUrls, setLoader, company) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    let urls = [];
    document.map((doc) => {
      const type = doc?.document_storage_info?.key?.split(".")[1];
      let url = "";
      if (authData?.type === "customer_user") {
        url = `/api/v1/${authData?.type}/${company}/media/${doc.document_storage_info.key}`;
      } else {
        url = `/api/v1/${authData?.type}/media/${doc.document_storage_info.key}`;
      }
      urls.push({
        url: url,
        name: doc.document_title,
        type: type,
        key: doc?.document_storage_info?.key,
      });
    });
    sendRequests(urls, setUrls, setLoader);
  } catch (e) {
    console.log(e);
  }
};

const sendRequests = async (urls, setUrls, setLoader) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    let num = urls.length;
    if (num === 0) {
      setLoader(false);
    }
    let n = 0;
    // eslint-disable-next-line no-unused-vars
    let promiseArr = urls.map((l) => {
      let PROD_URL = "";
      if (process.env.NODE_ENV === "development") {
        PROD_URL = process.env.REACT_APP_BACKEND_DEV_API_URL;
      } else {
        PROD_URL = process.env.REACT_APP_BACKEND_PRODUCTION_API_URL;
      }

      fetch(PROD_URL + l.url, {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
        method: "GET",
      })
        .then(async (resp) => {
          return resp.arrayBuffer();
        })
        .then(async (res) => {
          n++;
          if (l.type === "pdf") {
            const myFile = new Blob([res], { type: "application/pdf" });
            const url = URL.createObjectURL(myFile);
            setUrls((prev) => [
              ...prev,
              { url: url, name: l.name, type: l.type, key: l.key },
            ]);
          } else {
            const myFile = new Blob([res], { type: "image/png" });
            const url = URL.createObjectURL(myFile);
            setUrls((prev) => [
              ...prev,
              { url: url, name: l.name, type: l.type, key: l.key },
            ]);
          }
          if (n === num) {
            setLoader(false);
          }
        });
    });

    // setLoader(false);
  } catch (e) {
    console.log(e);
  }
};

function UpdateCustomerUser({ auths }) {
  const { user_id } = useParams();
  const [roles, setRoles] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [loader, setLoader] = useState(true);
  const [user, setUser] = useState([]);
  const [details, setDetails] = useState([]);
  const [urls, setUrls] = useState([]);
  const [up, setUp] = useState(0);

  useEffect(() => {
    setUser(auths?.user);
    getDetailsRolesCompanies(
      setRoles,
      setCompanies,
      setLoader,
      setDetails,
      user_id,
      setUrls,
      auths?.user?.customer_company?._id
    );
  }, []);
  useEffect(() => {
    if (up) {
      getDetailsRolesCompanies(
        setRoles,
        setCompanies,
        setLoader,
        setDetails,
        user_id,
        setUrls,
        auths?.user?.customer_company?._id
      );
    }
  }, [up]);
  if (!loader) {
    return (
      <React.Fragment>
        {/* <Brand /> */}
        <Helmet title="Alpha Plus" />
        {/* <BigAvatar alt="Lucy" src="/static/img/avatars/icon.png" /> */}
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              UPDATE CUSTOMER USER
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/users/customer-users">
                Customer Users
              </Link>
              <Typography>Update Customer User</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Signup
              urls={urls}
              id={user_id}
              user={user}
              roles={roles}
              companies={companies}
              details={details}
              comp={auths?.user?.customer_company?._id}
              setUrls={setUrls}
              up={up}
              setUp={setUp}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});
export default connect(mapStateToProps, null)(UpdateCustomerUser);
